














































import { GQL_invoiceOverdueNoticeFragments } from '@/queries/__generated__/invoiceOverdueNoticeFragments';
import { GQL_invoiceOverdueNoticeMailLogs } from '@/queries/__generated__/invoiceOverdueNoticeMailLogs';
import { GQL_logInvoiceOverdueNoticeMailFragments } from '@/queries/__generated__/logInvoiceOverdueNoticeMailFragments';
import gql from 'graphql-tag';
import { SmartQuery } from 'vue-apollo-decorator';
import { Component, Vue, Prop } from 'vue-property-decorator';

const INVOICE_OVERDUE_NOTICE_MAIL_LOGS = gql`
  query invoiceOverdueNoticeMailLogs($id: ID!) {
    invoice(id: $id) {
      id
      invoiceOverdueNotices {
        id
        issueDate
        dueDate
        additionalCharge
        orderNumber
        overdueNoticeLogs {
          id
          sentAt
          sentBy {
            id
            name
          }
          recipientMail
          deliveryStatus
          deliveryError
        }
      }
    }
  }
`;

@Component
export default class InvoiceOverdueNoticesLogs extends Vue {
  @Prop() private invoiceId!: number;
  @Prop() private invoiceOverdueNotice!: GQL_invoiceOverdueNoticeFragments;

  @SmartQuery<InvoiceOverdueNoticesLogs, GQL_invoiceOverdueNoticeMailLogs>({
    query() { return INVOICE_OVERDUE_NOTICE_MAIL_LOGS },
    variables() { return { id: this.invoiceId } },
    update(data) {
      if (!data.invoice) return [];
      const notice = data.invoice.invoiceOverdueNotices.find(notice => notice.id === this.invoiceOverdueNotice.id);
      if (notice) return notice.overdueNoticeLogs;
      return [];
    },
    fetchPolicy: 'no-cache',
  }) private logs!: GQL_logInvoiceOverdueNoticeMailFragments[];
}
